import React, { useEffect, useState } from "react";
import { Box, Typography, Grid, Tabs, Tab, TextField, Chip, Button, Table, TableBody, TableCell, TableContainer, TableHead, TableRow } from "@mui/material";
import Freez from '../../../Components/Loader/Loader'
import DefaultLayout from '../../../Components/DefaultLayout';
import Backdrop from '@mui/material/Backdrop';
import swal from "sweetalert";
import { useDispatch } from "react-redux";
import { fetchData, postData } from "../../../redux/apiSlice";
import { DataGrid } from "@mui/x-data-grid";
import * as Yup from 'yup';
import { Formik } from 'formik';
import { useNavigate } from "react-router-dom";

const Events = () => {
    const [freez, setFreez] = React.useState(false);
    const [activeTab, setActiveTab] = useState(0);
    const [events, setEvents] = useState([]);
    const [selectedRows, setSelectedRows] = useState([]);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const handleTabChange = (event, newValue) => {
        setActiveTab(newValue);
    };
    const handleFreezStop = () => {
        setFreez(false);
    };
    const handleFreezStart = () => {
        setFreez(true);
    };
    useEffect(() => {
        if (activeTab === 0) {
            fetchEvents();
        }
    }, [activeTab]);
    const fetchEvents = async () => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        handleFreezStart();
        const apiUrl = "/events/all";
        try {
            const res = await dispatch(fetchData(apiUrl)).unwrap();
            console.log(res);

            if (res && res.success === true) {
                setEvents(res.data);
            } else {
                swal("Error!", "Something went wrong!", "error");
            }
        } catch (error) {
            console.error("Error fetching events:", error);
            swal("Error!", "Failed to fetch events", "error");
        } finally {
            handleFreezStop();
        }
    };
    const columns = [
        { field: "event_name", headerName: "Event Name", flex: 1, width: 200 },
        { field: "event_start_date", headerName: "Start Date", flex: 1, width: 150 },
        { field: "event_end_date", headerName: "End Date", flex: 1, width: 150 },
        { field: "event_condition", headerName: "Condition", flex: 1, width: 100 },
        { field: "description", headerName: "Description", flex: 1, width: 300 },
    ];
    const EventSchema = Yup.object().shape({
        eventName: Yup.string().required('Event Name is required'),
        description: Yup.string().required('Event Description is required'),
        eventStartDate: Yup.date().required('Start Date is required'),
        eventEndDate: Yup.date().required('End Date is required'),
        eventCondition: Yup.string().required('Event Condition is required'),
    });
    const handleCreateEvent = async (values, { resetForm }) => {
        let token = localStorage.getItem("token");
        if (!token) {
            navigate('/login');
            return;
        }
        handleFreezStart();
        const apiUrl = "/events/create";
        const args = {
            eventName: values.eventName,
            description: values.description,
            eventStartDate: values.eventStartDate,
            eventEndDate: values.eventEndDate,
            eventCondition: values.eventCondition,
        };
        console.log("Form values before API call:", args);
        try {
            const res = await dispatch(postData({ apiUrl, args })).unwrap();

            if (res && res.success === true) {
                swal("Success!", "Event created successfully!", "success");
                resetForm();
                setActiveTab(0);
                fetchEvents();
            } else {
                swal("Error!", res.message || "Something went wrong!", "error");
            }
        } catch (error) {
            console.error("Error creating event:", error);
            swal("Error!", "Failed to create event", "error");
        } finally {
            handleFreezStop();
        }
    };

    const ContentLayout =
        <>
            <Box display="flex" justifyContent="space-between" alignItems="center">
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    EVENTS
                </Typography>
                <Button variant="contained" className="commonBtn" onClick={() => navigate("/email-editor")}>CREATE EMAIL</Button>
            </Box>
            <Tabs value={activeTab} onChange={handleTabChange} TabIndicatorProps={{ style: { backgroundColor: "#2A9005" } }}>
                <Tab label="All Events" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 0 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
                <Tab label="Create Event" sx={{ textTransform: "none", fontWeight: "bold", color: activeTab === 1 ? "#2A9005" : "inherit", "&.Mui-selected": { color: "#2A9005" } }} />
            </Tabs>
            {activeTab === 0 && (
                <Box sx={{ width: "100%", mx: "auto", mt: 1 }}>
                    <DataGrid
                        rows={events}
                        columns={columns}
                        getRowId={(row) => row.id}
                        pageSizeOptions={[10, 20, 50]}
                        pagination
                        paginationMode="client"                        
                        autoHeight
                        initialState={{
                            pagination: {
                                paginationModel: { pageSize: 10, page: 0 },
                            },
                        }}
                        sx={{
                            maxWidth: "100%",
                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#2E67BC",
                                color: "#fff",
                                fontWeight: "bold",
                            },
                        }}
                        onRowSelectionModelChange={(selectedIds) => {
                            const selectedData = events.filter(row => selectedIds.includes(row.id));
                            setSelectedRows(selectedData);
                        }}
                    />
                </Box>

            )}
            {activeTab === 1 && (
                <Formik
                    initialValues={{
                        eventName: '',
                        description: '',
                        eventStartDate: '',
                        eventEndDate: '',
                        eventCondition: '',
                    }}
                    validationSchema={EventSchema}
                    onSubmit={handleCreateEvent}
                >
                    {({ values, errors, touched, handleChange, handleBlur, handleSubmit }) => (
                        <form onSubmit={handleSubmit}>
                            <Box sx={{ mt: 3 }}>
                                <Grid container spacing={2}>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Event Name"
                                            variant="outlined"
                                            name="eventName"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.eventName}
                                            error={touched.eventName && Boolean(errors.eventName)}
                                            helperText={touched.eventName && errors.eventName}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Event Description"
                                            variant="outlined"
                                            name="description"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.description}
                                            error={touched.description && Boolean(errors.description)}
                                            helperText={touched.description && errors.description}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Event Start Date"
                                            variant="outlined"
                                            type="date"
                                            name="eventStartDate"
                                            InputLabelProps={{ shrink: true }}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.eventStartDate}
                                            error={touched.eventStartDate && Boolean(errors.eventStartDate)}
                                            helperText={touched.eventStartDate && errors.eventStartDate}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <Box display="flex" gap={1} flexWrap="wrap">
                                            <Chip label="Referral Bonus" variant="outlined" />
                                            <Chip label="Commission" variant="outlined" />
                                            <Chip label="Enrollments" variant="outlined" />
                                            <Chip label="Referred Affiliate Enrollments" variant="outlined" />
                                            <Chip label="Snapshot Enrollments" variant="outlined" />
                                        </Box>
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Event End Date"
                                            variant="outlined"
                                            type="date"
                                            name="eventEndDate"
                                            InputLabelProps={{ shrink: true }}
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.eventEndDate}
                                            error={touched.eventEndDate && Boolean(errors.eventEndDate)}
                                            helperText={touched.eventEndDate && errors.eventEndDate}
                                        />
                                    </Grid>
                                    <Grid item xs={12} sm={6}>
                                        <TextField
                                            fullWidth
                                            label="Event Condition"
                                            variant="outlined"
                                            name="eventCondition"
                                            onChange={handleChange}
                                            onBlur={handleBlur}
                                            value={values.eventCondition}
                                            error={touched.eventCondition && Boolean(errors.eventCondition)}
                                            helperText={touched.eventCondition && errors.eventCondition}
                                        />
                                    </Grid>
                                    <Grid item xs={12}>
                                        <Button variant="contained" className="commonBtn" type="submit">
                                            CREATE EVENT
                                        </Button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    )}
                </Formik>
            )}
        </>
    return (
        <>
            <DefaultLayout content={ContentLayout} />
            <div>
                <Backdrop
                    sx={{ color: '#fff', zIndex: (theme) => theme.zIndex.drawer + 1 }}
                    open={freez}
                    onClick={handleFreezStop}
                >
                    <Freez />
                </Backdrop>
            </div></>
    );
};

export default Events;
